export const FETCH_MARKET_ANALYSIS_DATA_SUCCESS = 'FETCH_MARKET_ANALYSIS_DATA_SUCCESS';